import { gql } from '@apollo/client';

export const fetchShipToIdsByCompanyNameQuery = gql`
  query fetchShipToIdsByCompanyName($searchParams: ShipToPartySearchParams, $pageParams: ShipToPartyPageParams) {
    shipToParty(searchParams: $searchParams, pageParams: $pageParams) {
      totalCount
      nodes {
        name
        id
      }
      pageInfo {
        endCursor
        hasNextPage
        __typename
      }
      __typename
    }
  }
`;
